export const PLAYER_GENDERS = {
  MALE: 'MALE',
  FEMALE: 'FEMALE'
}

export const TEAM_GENDERS = {
  BOYS: 'BOYS',
  GIRLS: 'GIRLS',
  MIXED: 'MIXED'
}
